import { inject, Injectable } from '@angular/core';
import { CommonService } from '@geneplanet/ngx-shop/src/lib/shared';
import { Language, TranslateService } from '@ngx-translate/core';

/**
 * Custom translate service will convert LocationCode to LanguageCode.
 * This is to make sure TranslateService will always have language, not location.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomTranslateService extends TranslateService {
  private readonly commonService = inject(CommonService);

  public override setFallbackLang(lang: Language) {
    return super.setFallbackLang(
      this.commonService.getLanguageCodeFromLocationCode(lang)
    );
  }

  public override use(lang: Language) {
    return super.use(this.commonService.getLanguageCodeFromLocationCode(lang));
  }
}
